<template>
    <div class="m-article-container">
        <div class="m-article-card" :class="theme" v-for="(article, index) in articles">
            <a class="m-article-img" :href="glb.appUrl + article.url">
                <div v-if="hasTag" class="m-article-tag" :label="tag">
                    <div class="f7">{{tag || article.firstSubCategoryName}}</div>
                    <div v-if="hasImageTitle">{{ article.title }}</div>
                </div>
                <img loading="lazy" :src="article.image" :alt="article.title"/>
            </a>
            <div class="m-article-content">
                <a class="m-article-title" :href="glb.appUrl + article.url">{{ article.title }}</a>
                <div class="m-article-description" v-html="article.description"></div>
                <div class="m-article-footer">
                    <a v-tip tip="author" role="button"><span class='subtxt'>By </span>{{ article.author }}</a>
                    <a class="float-right subtxt" role="button" v-tip tip="reviews">{{$filters.formatNumber(article.pageViews)}}<span> Views</span></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./markettrendsarticlecard.js"></script>

<style lang="scss">
@use "./markettrendsarticlecard.scss" as *;
</style>